<form [formGroup]="targetForm">
    <header class="info-tile-alt heading-row">
        <div *ngIf="hasAdminAccess" class="title-container">
            <h2>{{isClient? 'Add Client User' : 'Add KPMG User'}}</h2>
        </div>
        <div *ngIf="isClientAdmin" class="title-container">
            <h2>Add User</h2>
        </div>
        <div class="drawer-close" (click)="rightSideDrawerService.closeRightSideDrawer()"><i class="fas fa-times"
                aria-hidden="true"></i></div>
    </header>
    <section class="sideRight-body">
        <label for="ei-email">
            Email Address*
            <span class="required-error" *ngIf="!f.email.hasError('pattern') && IsEmailExists">Email address already exists.</span>           
            <span *ngIf="f.email.touched || f.email.dirty">
                <span class="required-error" *ngIf="!IsWhitelistDomain && !f.email.hasError('pattern')">Email must be part of one of the KPMG email domains.</span>              
                <span *ngIf="f.email.errors">
                    <span class="required-error" *ngIf="f.email.errors.required">(required)</span>                
                    <span class="required-error" *ngIf="f.email.hasError('pattern')">Email must be in a valid email address format.</span>  
                </span>
            </span>
            <input class="black-input opposite-colors" placeholder="Email" type="text" no-special-chars="#!$%^<>+="
                formControlName="email"  (keyup)="checkSigninName('email')" required>
        </label>
        <div class="options chkbox-opt chk-role-width">
            <label class="datatable-checkbox parent-checkbox kpmg-checkbox"> 
                <input type="checkbox" (change)="enableSigninName($event)" /><span>&nbsp;Sign-in name must be in a valid email address format.</span>
            </label>
        </div>
        <label *ngIf="enableSignIn" for="ei-name">
            Sign-in Name*
            <span class="required-error" *ngIf="!f.signinname.hasError('pattern') && IsSignInNameExists">Sign-in name already exists.</span>
            <span *ngIf="f.signinname.errors && (f.signinname.touched || f.signinname.dirty)">
                <span class="required-error" *ngIf="f.signinname.errors.required">(required)</span>
                <span class="required-error" *ngIf="f.signinname.hasError('pattern') && !IsSignInNameExists">Sign-in name must be in a valid email address format.</span>
            </span>
            <input class="black-input opposite-colors" placeholder="Sign-in Name" type="text"
                no-special-chars="#!$%^<>+=" formControlName="signinname" (keyup)="checkSigninName('signinname')"
                required />
        </label>

        <label for="ei-firstName">
            First Name
            <input class="black-input opposite-colors" placeholder="First Name of User" type="text"
                no-special-chars="#!$%^<>+=" formControlName="firstName"
                (keyup)="displayNameConcat($event,'firstName')" />
        </label>

        <label for="ei-lastName">
            Last Name
            <input class="black-input opposite-colors" placeholder="Last Name of User" type="text"
                no-special-chars="#!$%^<>+=" formControlName="lastName"
                (keyup)="displayNameConcat($event,'lastName')" />
        </label>

        <label for="ei-displayName">
            Display Name*
            <span
                *ngIf="f.displayName.errors && (f.displayName.touched || f.displayName.dirty) && !isDisplaynameEntered">
                <span class="required-error" *ngIf="f.displayName.errors.required">(required)</span>
            </span>
            <input class="black-input opposite-colors" (input)="displaynameInput()" placeholder="Display Name of User"
                type="text" no-special-chars="#!$%^<>+=" (blur)="trimSpecialCharName('displayName');"
                formControlName="displayName" [disabled]=true required />
        </label>
        
        <div class="input-with-icon" *ngIf="isClient && !isClientAdmin">
            Client Name*
            <ng-container *ngIf="!isClientMode">
                
                
                <ng-container *ngIf="isFromManageClientUserDrawer">
                    <input class="black-input opposite-colors" [readonly]="isFromManageClientUserDrawer"
                    [ngClass]="{'ng-invalid' :  (f.clientName.errors && (f.clientName.touched || f.clientName.dirty))}"
                    placeholder="Client Name" type="text" no-special-chars="#!$%^<>+=" [(ngModel)]="clientName"
                    formControlName="clientName" required />                
                </ng-container>
                <ng-container *ngIf="!isFromManageClientUserDrawer">
                    <span *ngIf="(f.clientName.touched && !isClientSelected)">
                        <span class="required-error"> (required)</span>
                    </span>
                    <input class="black-input opposite-colors clients-autocomplete" 
                        [ngClass]="{'ng-invalid' :  !isClientSelected }" 
                        placeholder="Search Existing Clients or Enter Client Name" type="text" no-special-chars="#!$%^<>+="
                        [kpmgUiTypeahead]="searchExistingClients" [resultTemplate]="ct" [editable]="true"
                        [inputFormatter]="clientFormatter" (input)="inputClient()" (selectItem)="onClientSelected($event)"
                        formControlName="clientName" [(ngModel)]="clientName">
                        <ng-template #ct let-c="result" let-t="term">
                            <kpmg-ui-highlight class="create-engagement-typeahead" [result]="c.clientName" [term]="t">
                            </kpmg-ui-highlight>&nbsp;
                        </ng-template>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="isClientMode" >
                <span *ngIf="f.clientName.errors && (f.clientName.touched || f.clientName.dirty)">
                    <span class="required-error"> (required)</span>
                </span>
                <input class="black-input opposite-colors"
                    [ngClass]="{'ng-invalid' :  (f.clientName.errors && (f.clientName.touched || f.clientName.dirty))}"
                    placeholder="Client Name" type="text" no-special-chars="#!$%^<>+=" [(ngModel)]="clientName"
                    formControlName="clientName" required />
            </ng-container>
        </div>



        <div *ngIf="!isClient" class="archive__toggle" style="padding-top: 10px;">
            <span class="mr-4">Contractor</span>
            <label class=" mr-2 archive-checkbox option-spacing" style="width: 40px;">
                <toggle-switch (toggleState)="IsContractor()"></toggle-switch><span></span>
            </label>
        </div>

        <div *ngIf="user.roleId === championRole && !isClient" class="additional-role">
            <h4 class="role-heading">Additional Roles</h4>
            <div class="archive__toggle" style="padding-top: 10px;">
                <span class="mr-4">Champion</span>
                <label class=" mr-2 archive-checkbox option-spacing" style="width: 40px;">
                    <toggle-switch (toggleState)="SetRoles(championRole)"></toggle-switch><span></span>
                </label>
            </div>


        </div>


    </section>
    <footer class="endFormSubmit info-tile">
        <button type='button' class="btn btn-success" (click)="postRightSideDrawerData()"
            [disabled]="!targetForm.valid || IsEmailExists || IsSignInNameExists || !isDisplaynameEntered || !IsWhitelistDomain">{{isClient?
            'Add Client User' : 'Add KPMG User'}}</button>
        <button class="btn kpmg-button--flat"
            (click)="rightSideDrawerService.closeRightSideDrawer();">Cancel</button>
    </footer>
</form>